// @flow
import type { State as RootState } from '../types'
import type { State } from './types'

export const selectUiTree = (state: RootState): State => state.ui
